import { AppProductTypeEnum } from 'src/graphql/schema';

type IProtectionOffering = {
  productType: AppProductTypeEnum;
  title: string;
  description: string;
  learnMoreUrl: string;
};

const ESCROW_PROTECTION_OFFERINGS: IProtectionOffering[] = [
  {
    productType: AppProductTypeEnum.SoftwareEscrow,
    title: 'Software Escrow',
    description: 'Store your on-premises source code and data, ready for fast recovery.',
    learnMoreUrl: 'https://codekeeper.co/software-escrow',
  },
  {
    productType: AppProductTypeEnum.SaasEscrow,
    title: 'SaaS Escrow',
    description: 'Protect your cloud environment so SaaS applications stay recoverable.',
    learnMoreUrl: 'https://codekeeper.co/saas-escrow',
  },
  {
    productType: AppProductTypeEnum.ContinuityEscrow,
    title: 'Continuity Escrow',
    description: 'Keep critical applications online with protected hosting and services.',
    learnMoreUrl: 'https://codekeeper.co/continuity-escrow',
  },
];

const ALL_PROTECTION_OFFERINGS: IProtectionOffering[] = [
  ...ESCROW_PROTECTION_OFFERINGS,
  {
    productType: AppProductTypeEnum.Backup,
    title: 'Software Backup',
    description: 'Back up your internal systems for disaster recovery and compliance.',
    learnMoreUrl: 'https://codekeeper.co/software-backup',
  },
  {
    productType: AppProductTypeEnum.CustodianProfile,
    title: 'Software Custodian',
    description: 'Manage compliance and accountability across your whole software life cycle.',
    learnMoreUrl: 'https://codekeeper.co/software-custodian',
  },
];

const PROTECTIONS_COMPARISON_URL = 'https://codekeeper.co/solutions';

export type { IProtectionOffering };
export { ESCROW_PROTECTION_OFFERINGS, ALL_PROTECTION_OFFERINGS, PROTECTIONS_COMPARISON_URL };
